import React, { useState } from 'react';

const QuestionsContext = React.createContext([{}, () => {}]);

const QuestionsProvider = (props) => {
    const [questionsState, setQuestionsState] = useState({
        theQuestions: [
            {
                _id: "Loading...",
                Title: "Loading...",
                Question: "Loading...",
                Type: "Loading...",
                Value: "Loading...",
                PlaceHolder: "Loading..."
            }
        ],
        theQuestion:
            {
                _id: "",
                Title: "",
                Question: "",
                Type: "",
                Value: "",
                PlaceHolder: ""
            },
    });
    return (
        <QuestionsContext.Provider value={[questionsState, setQuestionsState]}>
            {props.children}
        </QuestionsContext.Provider>
    );
};

export { QuestionsContext, QuestionsProvider };
